import Clarity from '@microsoft/clarity';
import type { BEClarityProps } from '.';



const WebClarityFunctions:BEClarityProps = {
    initializeClarity: (project_id:string):void => {
        Clarity.init(project_id);//Clarity start up
    },
    setCustomTag: (tag:string, value:string):void => {
        Clarity.setTag(tag, value);
    },
    identify: (player_id:string, session_id?:string):void => {
        Clarity.identify(player_id, session_id);
    },
    smartEvent: (event:string) => {
        Clarity.event(event);
    }
}

export default WebClarityFunctions




